import { useContext } from 'react';
// import { XMarkIcon } from '@heroicons/react/16/solid';
import { GlobalContext } from '../../providers/GlobalStatesProviders';


// styles
import './static/css/Modal.css'

const Modal = ({children}) => {
  const { isModalOpen, setIsModalOpen } = useContext(GlobalContext);
  
  return (
    <div className={`${isModalOpen? 'new-modal' : 'hidden'}`}>
      <div className='content-modal'>
        <div className='icon-modal'>
          <p onClick={() => setIsModalOpen(false)}>X</p>
          {/* <XMarkIcon
            className='size-6 text-gray-700 cursor-pointer'
            onClick={() => setIsModalOpen(false)}
          ></XMarkIcon> */}
        </div>
        <div className='children-modal'>
          {children}
        </div>

      </div>
    </div>
  )
}

export default Modal